// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZJ-z","twoColumnImage":"_J-z"};